
// import PopupConfirmDelete from "@/components/PopupConfirmDelete.vue";
import { ref, onMounted, computed, defineComponent } from "vue";
import { usePlugin } from "@/plugins";
import { clone, equals } from "ramda";
import {
  Competency,
  GetCompetencyResponse,
  UpsertCompetencyRequest,
} from "@/types";
import BackButton from "@/components/BackButton.vue";
import Fuse from "fuse.js";

export default {
  name: "Competency",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading, padZero } = usePlugin();

    const competencyTable = ref(null);
    const competencies = ref<Competency[]>([]);
    const competency = ref<Competency>({} as Competency);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const existCompetencyId = ref(false);
    const duplicateCompetencyId = ref(false);

    const filteredCompetency = computed(() => {
      if (!searchString.value) return competencies.value;
      const fuse = new Fuse(competencies.value, {
        keys: ["competencyId", "descriptionEN", "descriptionTH"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadCompetencies = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetCompetencyResponse>(
          "api/v1/services/competency/get"
        );
        competencies.value = result.data.competencies ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewCompetency = () => {
      competency.value = {} as Competency;
      showDialog.value = true;
      submitted.value = false;
      existCompetencyId.value = false;
    };

    const onSaveCompetency = async () => {
      submitted.value = true;
      if (competency.value.id && competency.value.id.length > 0) {
        if (
          !existCompetencyId.value &&
          competencies.value.find(
            (comp) => comp.id === padZero(competency.value.id, 3)
          )
        ) {
          //Create competency ID
          duplicateCompetencyId.value = true;
          return;
        }
        setLoading(true);
        try {
          const result = await axios.post("api/v1/services/competency/upsert", {
            competencies: [
              {
                id: padZero(competency.value.id, 3),
                descriptionEN: competency.value.descriptionEN,
                descriptionTH: competency.value.descriptionTH,
              },
            ],
          } as UpsertCompetencyRequest);
          await loadCompetencies();
          success("บันทึกข้อมูลสำเร็จแล้ว");
          showDialog.value = false;
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
      duplicateCompetencyId.value = false;
    };

    const onEditCompetency = (source: Competency) => {
      competency.value = clone(source);
      showDialog.value = true;
      existCompetencyId.value = true;
    };

    const onDeleteCompetency = (source: Competency) => {
      competency.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteCompetency = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/competency/delete", {
          data: {
            competencies: [competency.value],
          } as UpsertCompetencyRequest,
        });
        await loadCompetencies();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };

    onMounted(async () => {
      await loadCompetencies();
    });
    return {
      competencyTable,
      competency,
      competencies,
      filteredCompetency,
      showDialog,
      submitted,
      existCompetencyId,
      duplicateCompetencyId,
      popupDeleteDialog,
      searchString,
      onNewCompetency,
      onEditCompetency,
      onDeleteCompetency,
      onSaveCompetency,
      handleDeleteCompetency,
      onHideDialog,
    };
  },
};
